import React, { Component } from 'react'
import { connect } from 'react-redux';
// import CustomTable from '../../components/dataDisplay/CustomTable'
import { FormControl, FormGroup, FormControlLabel, Checkbox, TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';

class ModalGerente extends Component {  
    constructor() {
        super()

        this.state = {
            modalIsOpen: true,
            gerenciados: [],
            gerenciadosCarregados: false,
            manipulaDocumento: false,
        }

        this.manipulaDocumentoChange = this.manipulaDocumentoChange.bind(this);   

        this.closeModal = this.closeModal.bind(this)
    }

    // componentDidMount(){
    //     this.defineGerenciadosIniciais()
    //     console.log('=> GERENTE - GERENCIADOS DID MOUNT')
    // }

    componentDidUpdate(prev){
        // this.defineGerenciadosIniciais()
        if ((!this.props.gerente || !prev.gerente) && this.state.gerenciadosCarregados) {
            this.setState({ gerenciadosCarregados: false })
            // console.log('=> GERENTE - GERENCIADOS DID UPDATE TRUE: ')
        } else {
            this.defineGerenciadosIniciais()
            // console.log('=> GERENTE - GERENCIADOS DID UPDATE FALSE: ')
        }
    }

    closeModal(){
        console.log('=> GERENTE - GERENCIADOS FECHOU 1')
        this.props.closeModal()
    }

    salvarGerente(){
        const gerenteId = this.props.gerente.id
        const usuariosGerenciadosIds = this.state.gerenciados.map((gerenciado) => gerenciado.id)
        const manipulaDocumento = this.state.manipulaDocumento ? 'S' : 'N'

        this.props.salvarGerente(gerenteId, usuariosGerenciadosIds, manipulaDocumento)
        document.querySelector('#modalGerente #close').click()
    }

    removerGerente(){
        this.props.removerGerente(this.props.gerente.id)
        document.querySelector('#modalGerente #close').click()
    }

    defineGerenciadosIniciais(){
        const { gerente, loadGerente } = this.props
        const { gerenciadosCarregados } = this.state

        if (!loadGerente && !gerenciadosCarregados) {
            if (gerente) {
                this.setState({ gerenciados: gerente.gerenciados, gerenciadosCarregados: true, manipulaDocumento: gerente.isManipulaDocumento })
            }
        }
    }

    manipulaDocumentoChange(event) {
        this.setState({ manipulaDocumento: event.target.checked })
        return  event.target.checked
    }

    populaGerenciados(id, type = 'add'){
        const { listaUsuario } = this.props
        let { gerenciados } = this.state

        switch(type){
            case 'all':
                if(listaUsuario.length === gerenciados.length && type === 'all') {
                    this.setState({ gerenciados: [] })
                } else {
                    this.setState({ gerenciados: listaUsuario })
                }
                break;
            default:
                const novoGerenciado = gerenciados.find((gerenciado) => gerenciado.id === id)
                if(novoGerenciado){
                    const novoGerenciados = gerenciados.filter((gerenciado) => gerenciado.id !== id)
                    this.setState({ gerenciados: novoGerenciados })
                } else {
                    const find = listaUsuario.find((usuario) => usuario.id === id)
                    const novoGerenciados = [find].concat(gerenciados)
                    this.setState({ gerenciados: novoGerenciados })
                }
                break; 
        }
        return gerenciados
    }

    render(){
        const { listaUsuario, gerente, loadGerente } = this.props
        let { gerenciados, manipulaDocumento } = this.state
        console.log('=> GERENTE - GERENCIADOS: ', gerenciados)
        // this.defineGerenciadosIniciais()

        return (
            <div className="modal fade" id="modalGerente" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
            <div className="modal-dialog" role="document">

                <div className="modal-content">
                    
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">{`GERENTE${gerente ? ': ' + gerente.nome  + ' (' + gerente.cnpj + ')' : ''}`}</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div className="modal-body ">

                        {loadGerente
                            ? <div className="col text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>

                            : <div className="container text-left">
                                <div className="row">
                                    <div className="col">
                                    <FormControl>
                                    <FormGroup row>
                                        <FormControlLabel
                                            control={<Checkbox checked={manipulaDocumento} color="primary" onChange={this.manipulaDocumentoChange} name="manipulaDocumento" />}
                                            label="Pode manipular documentos"
                                        />
                                    </FormGroup>
                                    </FormControl>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <h5>Gerenciados</h5>
                                        <small className="text-muted">Usuários que podem ser gerenciados</small>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">

                                        <TableContainer>
                                            <Table> 
                                                <TableHead>
                                                    {
                                                        <TableRow>
                                                            <TableCell >
                                                                <Checkbox 
                                                                    checked={gerenciados.length === listaUsuario.length} 
                                                                    onClick={()=> this.populaGerenciados(-1,'all')} 
                                                                    color="primary" inputProps={{ 'aria-label': 'primary color' }} />
                                                            </TableCell>
                                                            <TableCell align="left">Nome</TableCell>
                                                            <TableCell align="left">CPF/CNPJ</TableCell>
                                                        </TableRow>
                                                    }
                                                </TableHead>
                                            </Table>
                                            <div style={{ overflow: 'auto', height: '250px' }}>
                                            <Table>
                                                <TableBody>
                                                    {
                                                        listaUsuario.length === 0 
                                                        ? <TableRow>
                                                            <TableCell key="sem_usuarios" component="th" scope="row" colSpan="2">
                                                                <p>Nenhum usuário encontrado...</p> 
                                                            </TableCell>
                                                        </TableRow>                                                        
                                                        : listaUsuario.map(row => (
                                                            <TableRow key={row.id}>
                                                                <TableCell component="th" scope="row">
                                                                    <Checkbox 
                                                                        checked={gerenciados.find(gerenciado => gerenciado.id === row.id) ? true : false}
                                                                        onClick={() => { this.populaGerenciados(row.id) }}
                                                                        color="default" inputProps={{ 'aria-label': 'checkbox with default color' }} />
                                                                </TableCell>
                                                                <TableCell align="left">{row.nome}</TableCell>
                                                                <TableCell align="left">{row.cnpj}</TableCell>
                                                            </TableRow>
                                                        ))
                                                    }
                                                </TableBody>
                                            </Table>
                                            </div>
                                        </TableContainer>

                                    </div>
                                </div>
                            </div>
                        }

                    </div>

                    <div className="modal-footer" style={{ display:'flex', alignItems:'center'}}>
                        <button disabled={loadGerente || !(gerenciados.length > 0)}
                            id="salvaGerente" type="button" className="btn btn-primary"
                            onClick={() => this.salvarGerente()}>
                            Salvar
                        </button>

                        <button disabled={loadGerente || !(gerente && gerente.gerenciados.length > 0)} 
                            id="removeGerente" type="button" className="btn btn-danger"
                            onClick={() => this.removerGerente()}>
                            Remover
                        </button>

                        <button disabled={loadGerente}
                            type="button" id="close" className="btn btn-dark" 
                            data-dismiss="modal">
                            Fechar
                        </button>

                    </div>
                </div>
            </div>
            {/* <ToastContainer autoClose={3000} position={toast.POSITION.BOTTOM_CENTER} draggable={false}/> */}
        </div>

        )
    }
}

const mapStateToProps = () => {
    return
}

export default connect(mapStateToProps, {})(ModalGerente);
